import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";

const PaymentsPage = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Ödemeler" />
      <div className="card">
        <div className="card-body">
          <h5>Ödemeler</h5>
          <p>Bu sayfa yakında eklenecek.</p>
        </div>
      </div>
    </MasterLayout>
  );
};

export default PaymentsPage;

